<!--forgot password Page Starts-->
<section id="login">
  <div class="row full-height-vh m-0">
    <div class="col-12 d-flex align-items-center justify-content-center">
      <div class="fondo-login d-flex align-items-center justify-content-center">
        <div class="card overflow-hidden">
          <div class="card-content">
            <div class="card-body">
              <div class="row m-0">
                <div class="col-12 justify-content-center align-items-center">
                  <img
                    src="assets/img/logo.png"
                    alt="logo"
                    class="img-fluid logo-login"
                    width="250"
                  />
                  <h4 class="text-center mt-2 text-white">
                    Restablecer Contraseña
                  </h4>
                  <div class="text-center mb-2 text-white">
                    <span class="small">
                      Introduzca su correo electrónico y presione<br /><b
                        >Aceptar</b
                      >, recibirá un E-mail con las instrucciones <br />para
                      restablecer su contraseña.</span
                    >
                  </div>
                  <form
                    autocomplete="off"
                    [formGroup]="user"
                    (ngSubmit)="guardar()"
                  >
                    <div class="form-group">
                      <input
                        class="form-control rounded"
                        type="email"
                        placeholder="Correo electrónico"
                        formControlName="email"
                        [class.is-invalid]="correoNoValido"
                      />
                      <small
                        *ngIf="correoNoValido"
                        class="text-danger text-left white"
                      >
                        Formato de correo no válido
                      </small>
                    </div>

                    <div class="form-group row">
                      <div class="input-group">
                        <button
                          type="submit"
                          [disabled]="!user.valid"
                          class="btn btn-secondary btn-block"
                        >
                          Aceptar
                        </button>
                      </div>
                    </div>
                  </form>
                  <div class="card-footer" style="cursor: pointer">
                    <div class="float-left mb-2 text-white">
                      <a (click)="onLogin()"
                        ><i class="fa fa-arrow-circle-left"></i> Volver a la
                        página de login
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer class="container-fluid"></app-footer>
</section>
<div
  *ngIf="spinner"
  class="spinner swal2-container swal2-center swal2-backdrop-show"
>
  <img class="spinner-img" src="../../../assets/img/logo-empresa.png" />
</div>
